import { render, staticRenderFns } from "./membership.vue?vue&type=template&id=23e27947"
import script from "./membership.vue?vue&type=script&lang=js"
export * from "./membership.vue?vue&type=script&lang=js"
import style0 from "./membership.vue?vue&type=style&index=0&id=23e27947&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e27947')) {
      api.createRecord('23e27947', component.options)
    } else {
      api.reload('23e27947', component.options)
    }
    module.hot.accept("./membership.vue?vue&type=template&id=23e27947", function () {
      api.rerender('23e27947', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/sections/membership.vue"
export default component.exports